/**
 * Highlighted Expertise widget: accordion + "View all expertise" popup.
 * Markup is rendered by templates/elementor/highlighted-expertise-accordion.php;
 * everything is found via data attributes so multiple instances can coexist.
 */
(function () {
  'use strict';

  function initAccordion(root) {
    if (root.dataset.heaInit === 'true') return;
    root.dataset.heaInit = 'true';

    var singleOpen = root.getAttribute('data-single-open') === 'true';
    var triggers = root.querySelectorAll('.hea__trigger');

    function panelFor(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function openPanel(panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      window.setTimeout(function () {
        if (panel.dataset.heaOpen === 'true') panel.style.maxHeight = 'none';
      }, 300);
      panel.dataset.heaOpen = 'true';
    }

    function closePanel(panel) {
      panel.dataset.heaOpen = 'false';
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        panel.style.maxHeight = '0px';
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (singleOpen && !expanded) {
          triggers.forEach(function (other) {
            if (other === trigger) return;
            other.setAttribute('aria-expanded', 'false');
            var otherPanel = panelFor(other);
            if (otherPanel && otherPanel.dataset.heaOpen === 'true') closePanel(otherPanel);
          });
        }

        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = panelFor(trigger);
        if (panel) expanded ? closePanel(panel) : openPanel(panel);
      });
    });
  }

  function initModal(modal) {
    if (modal.dataset.heaInit === 'true') return;
    modal.dataset.heaInit = 'true';

    // Move to <body> so no transformed/overflow ancestor can clip the fixed overlay.
    document.body.appendChild(modal);

    var baseUrl = modal.getAttribute('data-base-url') || '/expertise/';
    var items = modal.querySelectorAll('[data-hea-list] li');
    var empty = modal.querySelector('[data-hea-empty]');
    var sel = { sector: [], type: [] };
    var opener = null;

    function apply() {
      var shown = 0;
      items.forEach(function (li) {
        var sectors = li.dataset.sectors ? li.dataset.sectors.split(',') : [];
        var types = li.dataset.types ? li.dataset.types.split(',') : [];
        var ok =
          (!sel.sector.length || sectors.some(function (v) { return sel.sector.indexOf(v) > -1; })) &&
          (!sel.type.length || types.some(function (v) { return sel.type.indexOf(v) > -1; }));
        li.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      empty.classList.toggle('is-hidden', shown > 0 || (!sel.sector.length && !sel.type.length));
    }

    function reset() {
      sel = { sector: [], type: [] };
      modal.querySelectorAll('[data-hea-filter]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('!text-primary-500', '!border-primary-500', 'is-last-clicked');
      });
      apply();
    }

    function open(from) {
      opener = from;
      reset();
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Focus the dialog itself, not the first filter button, so no filter
      // shows the .hub-btn:focus ring (looks selected) until one is clicked.
      var dialog = modal.querySelector('.hea-modal__dialog');
      if (dialog) dialog.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.style.overflow = '';
      reset();
      if (opener) opener.focus();
    }

    document.querySelectorAll('[data-hea-modal-open="' + modal.id + '"]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn); });
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) return close();

      var f = e.target.closest('[data-hea-filter]');
      if (f) {
        var list = sel[f.dataset.heaFilter];
        var i = list.indexOf(f.dataset.value);
        i > -1 ? list.splice(i, 1) : list.push(f.dataset.value);
        var on = i === -1;
        f.setAttribute('aria-pressed', on ? 'true' : 'false');
        f.classList.toggle('!text-primary-500', on);
        f.classList.toggle('!border-primary-500', on);
        // Thicker border until focus leaves. Focus explicitly since Safari and
        // Firefox on macOS don't focus buttons on click (so blur wouldn't fire).
        f.classList.add('is-last-clicked');
        f.focus();
        return apply();
      }

      var go = e.target.closest('[data-hea-go]');
      if (go) {
        var q = [];
        if (sel.sector.length) q.push('lls=' + sel.sector.join(','));
        if (sel.type.length) q.push('etype=' + sel.type.join(','));
        window.location.href = baseUrl + go.dataset.heaGo + (q.length ? '?' + q.join('&') : '');
      }
    });

    modal.addEventListener('focusout', function (e) {
      if (e.target.matches('[data-hea-filter]')) e.target.classList.remove('is-last-clicked');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-hea]').forEach(initAccordion);
    document.querySelectorAll('[data-hea-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when Elementor mounts/re-renders the widget in the editor.
  document.addEventListener('elementor-widget-mounted', init);
})();
